import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type Props = {
  scrollValue?: number;
};

export default function ScrollToTop({ scrollValue }: Props) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(scrollValue || 0, 0);
  }, [pathname]);

  return null;
}
